import * as React from 'react';
import { connect } from 'react-redux';

import BrandProfileEditFormContainer from './BrandProfileEditFormContainer';
import { addUserAction } from 'modules/tracking/providers/user-action-provider';

import { createBrandProfile, resetBrandProfile } from '../reducers/brandProfile';

import type { BrandProfile, BrandProfileForm } from 'types';

type OwnProps = {
  organizationId: number,
  organizationType: string,
  onAfterSave: (profile?: BrandProfile) => Promise<any>
}

type StateProps = {
  brandProfileId?: number
};

type DispatchProps = {
  dispatchCreateBrandProfile: (profileDetails: BrandProfileForm, orgId: number) => Promise<BrandProfile>,
  dispatchResetBrandProfile: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

class BrandCreateProfile extends React.Component<Props> {
  componentDidMount() {
    const { dispatchResetBrandProfile, organizationType } = this.props;

    dispatchResetBrandProfile();
    addUserAction({
      eventCategory: 'drop down',
      eventAction: 'navigate',
      stage: 'finish',
      destination: organizationType.indexOf('brand') > -1 ? 'brand' : 'creator'
    });
  }

  componentDidUpdate(prevProps: Props) {
    const { organizationId, organizationType } = this.props;
    if (prevProps.organizationId !== organizationId) {
      addUserAction({
        eventCategory: 'drop down',
        eventAction: 'navigate',
        stage: 'finish',
        destination: organizationType.indexOf('brand') > -1 ? 'brand' : 'creator'
      });
    }
  }

  handleSave = (profileDetails: BrandProfileForm) => {
    const { organizationId, dispatchCreateBrandProfile } = this.props;

    return dispatchCreateBrandProfile(profileDetails, organizationId);
  };

  render() {
    const { organizationId, brandProfileId, organizationType, onAfterSave } = this.props;

    return (
      <section className="brand-profile layout-container-narrow">
        <BrandProfileEditFormContainer
          key={`${organizationId} - ${brandProfileId}`}
          mode="create"
          onSave={this.handleSave}
          onAfterSave={onAfterSave}
          organizationType={organizationType}
        />
      </section>
    );
  }
}

const mapStateToProps = ({ brandProfile }): StateProps => ({
  brandProfileId: brandProfile?.profile?.id
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchCreateBrandProfile: (profileDetails, orgId) => dispatch(createBrandProfile(profileDetails, orgId)),
  dispatchResetBrandProfile: () => dispatch(resetBrandProfile())
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandCreateProfile);
